export default function ChatDateSeparator({ label }) {
  if (!label) return null;

  return (
    <div className="flex justify-center py-4 w-full">
      <span className="text-[11px] font-semibold text-slate-500 bg-white/90 border border-slate-200/80 px-3 py-1 rounded-full shadow-sm">
        {label}
      </span>
    </div>
  );
}